import { Container } from "react-bootstrap";
import diaBanner from "../../assets/img/inner-banner/Diamond-Jewelry-Reports.webp";
import diaBannerMobile from "../../assets/img/mobile-banner/Diamond-Jewelry-Reports.webp";

import fancydiamond from "../../assets/img/Icons-Certificate/Fancy-Diamond.jpg";
import fulldiamond from "../../assets/img/Icons-Certificate/Full-Diamond.jpg";
import report from "../../assets/img/Icons-Certificate/Lab-Grown-Reports.jpg";
import "./Certificatedetail.css";
import { Link } from "react-router-dom";
import {
  MdKeyboardDoubleArrowRight,
  MdOutlineKeyboardDoubleArrowRight,
} from "react-icons/md";
import { Helmet } from "react-helmet";

export default function DiamondJewelryReports() {
  return (
    <>
      <Helmet>
        {/* Meta tags */}
        <title>
          Diamond Jewelry Grading Report | Sreehari Diamond Laboratory{" "}
        </title>
        <meta
          name="description"
          content="Ensure the authenticity of your diamond jewelry with a certified report. Learn how jewelry grading works for rings, earrings, and custom pieces."
        />
        <meta
          name="keywords"
          content="lab grown diamond certification, best diamond certification in india, Gemstone Identification Lab, Diamond, Gemological Laboratory, Diamond Testing Lab, Diamond Sealing service, Diamond Hologram Stickers, Hologram Stickers for Certificates, Best diamond online services, 4 cs' of diamonds, 4cs education of diamond"
        />
        {/* OG tags */}
        <meta
          property="og:title"
          content="Diamond Jewelry Grading Report | Sreehari Diamond Laboratory "
        />
        <meta
          property="og:description"
          content="Ensure the authenticity of your diamond jewelry with a certified report. Learn how jewelry grading works for rings, earrings, and custom pieces."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://sreeharidiamondlab.com/diamond-jewelry-reports"
        />
        <meta
          property="og:image"
          content="https://sreeharidiamondlab.com/static/media/Diamond-Jewelry-Reports.1ffd18a48afbfc12b09e.webp"
        />
        <meta property="og:site_name" content="sreehari diamond laboratory" />
        {/* Twitter tags */}
        <meta
          name="twitter:title"
          content="Diamond Jewelry Grading Report | Sreehari Diamond Laboratory "
        />
        <meta
          name="twitter:description"
          content="Ensure the authenticity of your diamond jewelry with a certified report. Learn how jewelry grading works for rings, earrings, and custom pieces."
        />
        <meta
          name="twitter:image"
          content="https://sreeharidiamondlab.com/static/media/Diamond-Jewelry-Reports.1ffd18a48afbfc12b09e.webp"
        />
        <meta name="twitter:site" content="sreehari diamond laboratory" />
        <link
          rel="canonical"
          href="https://sreeharidiamondlab.com/diamond-jewelry-reports"
        />{" "}
      </Helmet>
      <section>
        <Container fluid className="bannersection position-relative p-0">
          <img
            src={window.innerWidth > 568 ? diaBanner : diaBannerMobile}
            alt="Service banner"
            className="w-100  h-100 object-fit-cover about-banner-img"
          />
          <h2>Beyond the sparkle we certify the soul</h2>

          <div className="textoverlay pt-5 d-flex flex-column justify-content-center align-items-center position-absolute top-0 w-100 h-100 text-center"></div>
        </Container>
      </section>
      <section className="hologram-section section-spacing-x section-spacing-y pb-0">
        <div className="container-fluid">
          <div className="row">
            <h1 className="heading mb-3 text-center">
              Diamond Jewelry Reports{" "}
            </h1>
          </div>
          <p className="mb-1">
            We provide independent and expert information on the jewelry item,
            and the diamond set in it, with total carat weight, color, clarity,
            as well as a high-resolution picture of the jewelry. We give clear
            documentation to enable the owner to see exactly what the jewelry
            contains.
          </p>
          <p className="mb-1">
            The Diamond Jewellery Report is an advanced certification document
            that includes a tamper-proof hologram for enhanced security and
            authenticity. It provides comprehensive details about the jewellery
            piece, including the cut, colour, clarity, carat weight, and total
            number of diamonds, along with a precise description of the gold's
            characteristics, and also a high-resolution picture of specific
            diamond jewellery.
          </p>
          <p className="mb-1">
            This report is presented in a premium, elegantly designed format.
            The high-resolution picture provides extra clarity about the diamond
            jewellery with its certificates.
          </p>
          <p>
            This certificate is Soo handy, pocket-sized, slim-profile.
            Space-efficient, streamlined design. waterproof sealed against
            spills. Durable finish.
          </p>
          <div className="contact-us-button mt-lg-4 mb-lg-3 mb-4">
            <Link to="/contact-us">
              Contact Us <MdOutlineKeyboardDoubleArrowRight />
            </Link>
          </div>
        </div>
      </section>

      <section className="section-spacing-x">
        <div className="container-fluid">
          <div className="row mb-5">
            <h2 className="text-center mb-4 heading">Other Certificates</h2>
            <div className="col-lg-4 mb-lg-0 mb-3">
              <div className="service-card text-center border rounded">
                <div className="service-image mx-auto">
                  <img
                    src={fulldiamond}
                    alt="Full Diamond Grading Report | Sreehari Diamond Laboratory"
                    className="img-fluid"
                  />
                </div>
                <Link to="/full-diamond-grading-reports">
                  <h3 className="mb-0">Full Diamond Grading Reports</h3>
                </Link>
                <p className="mb-3c">
                  Our diamond grading reports deliver precise analysis of cut,
                  color, clarity, and carat, providing trustworthy certification
                  that reflects the true quality and value of your diamonds.{" "}
                </p>
                <div className="service-read-more mt-lg-0 mt-2">
                  <Link to="/full-diamond-grading-reports">
                    Read More
                    <MdKeyboardDoubleArrowRight />
                  </Link>
                </div>
              </div>
            </div>

            <div className="col-lg-4  mb-lg-0 mb-3">
              <div className="service-card text-center border rounded">
                <div className="service-image mx-auto">
                  <img
                    src={fancydiamond}
                    alt="Fancy Diamond Report | Sreehari Diamond Laboratory"
                    className="img-fluid"
                  />
                </div>
                <Link to="/fancy-diamond-reports">
                  <h3 className="mb-0">Fancy Diamond Reports</h3>
                </Link>
                <p className="mb-3">
                  Our Diamond reports specialize in grading unique colored
                  diamonds, detailing hue, tone, saturation, and quality to
                  certify the beauty and rarity of your fancy gemstones.{" "}
                </p>
                <div className="service-read-more mt-lg-0 mt-2">
                  <Link to="/fancy-diamond-reports">
                    Read More
                    <MdKeyboardDoubleArrowRight />
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="service-card text-center border rounded p-2">
                <div className="service-image mx-auto">
                  <img
                    src={report}
                    alt="Lab Grown Report |Sreehari Diamond Laboratory"
                    className="img-fluid"
                  />
                </div>
                <Link to="/lab-grown-reports">
                  <h3 className="mb-0">Lab Grown Reports</h3>
                </Link>
                <p className="mb-3">
                  Get reliable lab-grown diamond reports that verify
                  authenticity, quality, and characteristics, ensuring
                  transparency and confidence when buying or selling synthetic
                  diamonds.{" "}
                </p>
                <div className="service-read-more mt-lg-0 mt-2 ">
                  <Link to="/lab-grown-reports">
                    Read More
                    <MdKeyboardDoubleArrowRight />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
